import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

import themeStyles from './layout-loader.theme.style';

class LayoutLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { classes, loadingText } = this.props;
    return (
      <div className={classes.loaderWrapper}>
        <CircularProgress className={classes.progress} size={50} />
        <div className={classes.loaderText}>{loadingText ? loadingText : 'Loading...'}</div>
      </div>
    );
  }
}

LayoutLoader.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  loadingText: PropTypes.string
};


export default withStyles(themeStyles, { withTheme: true })(LayoutLoader);



// WEBPACK FOOTER //
// ./src/layouts/components/layout-loader/layout-loader.component.js